/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckOperator {
    GTE = 'GTE',
    LTE = 'LTE',
    GT = 'GT',
    LT = 'LT',
    EQ = 'EQ',
    NEQ = 'NEQ',
    CONTAINS = 'CONTAINS'
}


export function instanceOfPaxCheckOperator(value: any): boolean {
    for (const key in PaxCheckOperator) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckOperator, key)) {
            if (PaxCheckOperator[key as keyof typeof PaxCheckOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckOperatorFromJSON(json: any): PaxCheckOperator {
    return PaxCheckOperatorFromJSONTyped(json, false);
}

export function PaxCheckOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckOperator {
    return json as PaxCheckOperator;
}

export function PaxCheckOperatorToJSON(value?: PaxCheckOperator | null): any {
    return value as any;
}

export function PaxCheckOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckOperator {
    return value as PaxCheckOperator;
}

